<template>
  <section>
    <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="false"></b-loading>
    <h1 class="section-head">ตั้งค่าทั่วไป</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <button class="button is-danger is-pulled-left" @click="$router.go(-1)"><i class="fas fa-arrow-left"></i>Back</button>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button class="button is-success is-pulled-right" :class="loadingClass" @click="submit"><i class="fas fa-clipboard-list"></i>บันทึก</button>
          </div>
        </div>
      </div>
    </nav>

    <h3 class="section-sub-head">รายละเอียดบริษัท</h3>
        <div class="column">

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ชื่อบริษัท</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="ชื่อบริษัท" v-model="config.company_name">
              <span class="icon is-small is-left">
                <i class="fas fa-user"></i>
              </span>
            </p>
          </div>

        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">ที่อยู่</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="ที่อยู่" v-model="config.address">
              <span class="icon is-small is-left">
                <i class="fas fa-map-marker-alt"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">เบอร์โทรศัพท์</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="เบอร์โทรศัพท์" v-model="config.phone">
              <span class="icon is-small is-left">
                <i class="fas fa-phone"></i>
              </span>
            </p>
          </div>

          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Fax.</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="Fax." v-model="config.fax">
              <span class="icon is-small is-left">
                <i class="fas fa-phone"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">E-Mail</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="E-Mail" v-model="config.email">
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>


      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">เลขผู้เสียภาษี</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control has-icons-left">
              <input class="input " type="text" placeholder="เลขผู้เสียภาษี" v-model="config.tax_no">
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </p>
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
          <div class="field">
          </div>
        </div>
      </div>
    </div>


    <h3 class="section-sub-head">ข้อความลงท้าย ใบส่งสินค้า/ใบกำกับภาษี/ใบวางบิล</h3>
    <wysiwyg v-model="config.order_pdf_message" />


    <h3 class="section-sub-head">ข้อความลงท้าย ใบเสร็จ</h3>
    <wysiwyg v-model="config.receipt_pdf_message" />


    <h3 class="section-sub-head">ข้อความลงท้าย PO</h3>
    <wysiwyg v-model="config.po_pdf_message" />

    <h3 class="section-sub-head">Pre-Script ใบเสนอราคา</h3>
    <wysiwyg v-model="config.quatation_prescript_message" />

    <h3 class="section-sub-head">Post-Script ใบเสนอราคา</h3>
    <wysiwyg v-model="config.quatation_postscript_message" />



  </section>
</template>

<script>
  import Request from '@/libraries/request'
  import ConfigModel from '@/model/config_model'
  export default {

    data () {
      return {
        config: {},
        loadingClass: "",
        isLoading: true,
      }
    },
    mounted() {
      this.isLoading = true;
      this.init();
    },
    methods: {
      async init(){
        this.config = await ConfigModel.get_config();
        this.isLoading = false;
      },
      submit() {
        this.loadingClass = "is-loading";
        let data = {};
        data.options = this.config;
        Request.post('config/add',data, (res) => {
          if(res.data.status){
            this.$buefy.snackbar.open('บันทึกสำเร็จ!');
            this.loadingClass = "";
            this.$router.push('/config');
          }
        });
      },

    }
  }
</script>


<style>
  @import "vue-wysiwyg/dist/vueWysiwyg.css";
</style>




// WEBPACK FOOTER //
// src/pages/Config/index.vue